
import React, { useState, useEffect } from 'react';
import { TestimonialSkeleton } from '../../../components/base/SkeletonLoader';
import { AnimatedSection } from '../../../components/base/AnimatedSection';

export const TestimonialsSection: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  // Simular carregamento inicial
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1200);
    return () => clearTimeout(timer);
  }, []);

  const testimonials = [
    {
      id: 1,
      name: 'Marcelo B',
      service: 'Estética Completa',
      rating: 5,
      date: '2024-01-15',
      comment: 'Atendimento e serviço que supera muito as expectativas. Não pense em mais nenhuma estética automotiva. Vai lá sem pensar. A Talita e o Gabriel são 10!',
      timeAgo: '3 meses atrás'
    },
    {
      id: 2,
      name: 'Germano Rossetto',
      service: 'Estética Personalizada',
      rating: 5,
      date: '2024-03-10',
      comment: 'Obtive a recomendação da Aura de parte do meu mecânico. O atendimento é cordial e eficiente. O orçamento é claro e personalizável, conforme a necessidade e o bolso do cliente. Considerei os preços justos. A execução do serviço foi muito bem feita. Recomendo a quem precisa cuidar da estética do seu veículo.',
      timeAgo: '1 mês atrás'
    },
    {
      id: 3,
      name: 'Jeyson Macedo',
      service: 'Múltiplos Serviços',
      rating: 5,
      date: '2023-11-08',
      comment: 'Encontrei a Empresa em uma busca no Google, logo os contatei e fui atendido. Notei que são estruturados durante do atendimento via WhatsApp, que foi rápido e muito profissional. O tempo de execução do serviço foi dentro do esperado, não atrasou. A qualidade do serviço foi algo que me surpreendeu. São extremamente cuidadosos com TUDO. O meu carro entrou de uma forma e saiu do outra. Gostei, vou voltar e indico com certeza! Parabéns pelo excelente trabalho.',
      timeAgo: '5 meses atrás'
    }
  ];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  // Auto-rotate testimonials
  useEffect(() => {
    if (!isLoading) {
      const interval = setInterval(nextTestimonial, 6000);
      return () => clearInterval(interval);
    }
  }, [isLoading]);

  if (isLoading) {
    return (
      <section className="py-20 bg-[#0D0D0D]">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <div className="h-8 bg-gray-300 rounded w-64 mx-auto mb-4 animate-pulse"></div>
            <div className="h-4 bg-gray-300 rounded w-96 mx-auto animate-pulse"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {Array.from({ length: 3 }).map((_, index) => (
              <TestimonialSkeleton key={index} />
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-12 md:py-20 bg-[#0D0D0D]">
      <div className="container mx-auto px-4">
        <AnimatedSection animation="fadeIn" className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-montserrat font-bold text-white mb-4 px-4">
            O que nossos <span className="text-[#C8A45D]">clientes</span> dizem
          </h2>
          <p className="text-gray-300 text-base md:text-lg max-w-2xl mx-auto mb-4 md:mb-6 px-4">
            Avaliações reais de clientes satisfeitos com nossos serviços
          </p>
          
          {/* Google Rating Summary */}
          <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4 mb-6 md:mb-8 px-4">
            <div className="flex items-center gap-2">
              <i className="ri-google-fill text-xl md:text-2xl text-[#4285F4]"></i>
              <span className="text-white font-semibold text-sm md:text-base">Google</span>
            </div>
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-[#FFD700] text-sm md:text-lg"></i>
              ))}
              <span className="text-white font-bold ml-2 text-sm md:text-base">5.0</span>
            </div>
            <span className="text-gray-400 text-xs md:text-sm">50+ avaliações</span>
            <div className="flex items-center gap-1 text-[#C8A45D]">
              <i className="ri-verified-badge-fill text-sm"></i>
              <span className="text-xs md:text-sm">Verificado</span>
            </div>
          </div>
        </AnimatedSection>

        {/* Testimonial Carousel */}
        <div className="relative max-w-5xl mx-auto">
          <AnimatedSection animation="fadeIn" delay={200}>
            <div className="bg-[#1C1C1C] rounded-xl p-4 md:p-8 border border-[#333] relative overflow-hidden mx-4 md:mx-0">
              {/* Background Pattern */}
              <div className="absolute top-0 right-0 w-16 h-16 md:w-32 md:h-32 opacity-5">
                <i className="ri-double-quotes-r text-4xl md:text-8xl text-[#C8A45D]"></i>
              </div>
              
              <div className="relative z-10">
                {/* Stars */}
                <div className="flex justify-center mb-3 md:mb-4">
                  {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-[#FFD700] text-lg md:text-xl"></i>
                  ))}
                </div>

                {/* Comment */}
                <blockquote className="text-white text-sm sm:text-base md:text-lg lg:text-xl text-center mb-4 md:mb-6 leading-relaxed max-w-4xl mx-auto px-2">
                  "{testimonials[currentTestimonial].comment}"
                </blockquote>

                {/* Author Info */}
                <div className="text-center">
                  <h4 className="text-white font-semibold text-base md:text-lg">
                    {testimonials[currentTestimonial].name}
                  </h4>
                  <p className="text-[#C8A45D] text-xs md:text-sm">
                    {testimonials[currentTestimonial].service}
                  </p>
                  <p className="text-gray-400 text-xs">
                    {testimonials[currentTestimonial].timeAgo}
                  </p>
                </div>
              </div>
            </div>
          </AnimatedSection>

          {/* Navigation Arrows - Responsivos */}
          <button
            onClick={prevTestimonial}
            className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 bg-[#C8A45D] rounded-full flex items-center justify-center hover:bg-[#D4B76A] transition-colors duration-300"
          >
            <i className="ri-arrow-left-line text-black text-sm md:text-base"></i>
          </button>
          <button
            onClick={nextTestimonial}
            className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 bg-[#C8A45D] rounded-full flex items-center justify-center hover:bg-[#D4B76A] transition-colors duration-300"
          >
            <i className="ri-arrow-right-line text-black text-sm md:text-base"></i>
          </button>
        </div>

        {/* Dots Indicator */}
        <div className="flex justify-center gap-2 mt-6 md:mt-8">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentTestimonial(index)}
              className={`w-2 h-2 md:w-3 md:h-3 rounded-full transition-all duration-300 ${
                index === currentTestimonial ? 'bg-[#C8A45D] scale-125' : 'bg-gray-600 hover:bg-gray-500'
              }`}
            />
          ))}
        </div>

        {/* CTA */}
        <AnimatedSection animation="fadeIn" delay={400} className="text-center mt-8 md:mt-12 px-4">
          <button
            onClick={() => window.open('https://wa.me/554888397243?text=Olá! Vi as avaliações e gostaria de agendar um serviço na Aura Estética Automotiva.', '_blank')}
            className="bg-gradient-to-r from-[#C8A45D] to-[#D4B76A] text-black px-4 md:px-8 py-2 md:py-3 rounded-lg font-semibold hover:from-[#D4B76A] hover:to-[#E0C376] transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer text-sm md:text-base w-full sm:w-auto max-w-sm mx-auto"
          >
            <i className="ri-whatsapp-line mr-2"></i>
            Quero Ser o Próximo Cliente Satisfeito
          </button>
        </AnimatedSection>
      </div>
    </section>
  );
};